// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__kvQ9x","productName":"Table_productName__23tYn"};